export default __webpack_public_path__ + "static/media/loremnew.c8f7adb8.webp";